import type { Dispatch } from 'redux';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { AvatarPickerDialog as AvatarPicker } from '@atlaskit/media-avatar-picker';
import { connect } from '@atlassian/jira-react-redux';
import type { AvatarDetails } from '../../model/types';
import {
	hasFetchAvatarErrorSelector,
	projectPredefinedAvatarsSelector,
} from '../../state/entities/selectors';
import type { AppState } from '../../state/types';
import {
	closeAvatarPickerDialog,
	onChoosePredefinedAvatar,
	type ProjectDetailsUIAction,
	showFetchAvatarsErrorFlag,
	uploadAvatar,
} from '../../state/ui/actions';
import { projectAvatarUiSelector } from '../../state/ui/selectors';
import AvatarPickerDialog from './view';

const mapDispatchToProps = (dispatch: Dispatch<ProjectDetailsUIAction>) => ({
	onCloseAvatarPickerDialog: () => {
		dispatch(closeAvatarPickerDialog());
	},
	onSaveImage(
		file: File,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		croppingProperties: any /* typeof CroppingProperties(@atlaskit/media-avatar-picker) */,
		event: UIAnalyticsEvent,
	) {
		dispatch(uploadAvatar(file, croppingProperties, event));
	},
	onSavePredefinedAvatar(avatar: AvatarDetails) {
		dispatch(onChoosePredefinedAvatar(avatar));
	},
	onShowFetchAvatarsErrorFlag() {
		dispatch(showFetchAvatarsErrorFlag());
	},
});

export default connect(
	(state: AppState) => ({
		selectedAvatar: projectAvatarUiSelector(state),
		avatars: projectPredefinedAvatarsSelector(state),
		AvatarPicker,
		hasFetchAvatarError: hasFetchAvatarErrorSelector(state),
	}),
	mapDispatchToProps,
)(AvatarPickerDialog);
